import { ReactNode } from 'react'
import CopyButton from '@/components/copy-button'
import { cx } from '@/utils/strings'

export type CalloutProps = {
  contentful_id: string
  type: 'info' | 'warning' | 'success' | 'example'
  className?: string
  children: ReactNode
  hideHeader?: boolean
}

export default function Callout({ contentful_id: id, type, children, className, hideHeader = false }: CalloutProps) {
  const title = {
    warning: 'warning',
    info: 'note',
    success: 'tip',
    example: 'example',
  }
  const icons = {
    warning: '\ue94b',
    info: '\ue952',
    success: '\ue953',
    example: '\ue953',
  }
  return (
    <div
      className={cx(
        'callout',
        type === 'warning' && `border-l-warning`,
        type === 'info' && `callout--info`,
        type === 'success' && `border-l-success`,
        type === 'example' && `border-l-indigoBlue dark:border-l-teal-600`,
        className
      )}
    >
      {type === 'example' && (
        <div className="float-right">
          <CopyButton id={id} theme="light" className="text-sm" />
        </div>
      )}

      {!hideHeader && (
        <h5
          className={cx(
            `flex items-center mb-2 text-2xl capitalize`,
            type === 'warning' && `text-warning`,
            type === 'info' && `text-primary-700 dark:text-primary-100`,
            type === 'success' && `text-success`,
            type === 'example' && `text-indigoBlue dark:text-teal-600`
          )}
        >
          <span className="font-bwi mr-1">{icons[type]}</span>
          {title[type]}
        </h5>
      )}
      <section id={id}>{children}</section>
    </div>
  )
}
